import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, MapPinIcon, ShoppingBagIcon, XIcon } from 'lucide-react';
import { recentPurchases } from '../data/content';
export function FloatingElements() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [index, setIndex] = useState(0);
  const [cta, setCta] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const delay = index === 0 ? 5000 : 8000;
    const showTimer = window.setTimeout(() => setVisible(true), delay);
    const rotateTimer = window.setTimeout(() => {
      setVisible(false);
      setIndex(value => (value + 1) % recentPurchases.length);
    }, delay + 5500);
    return () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(rotateTimer);
    };
  }, [dismissed, index]);
  useEffect(() => {
    const onScroll = () => setCta(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const [name, city, plan] = recentPurchases[index];
  return <>
      <AnimatePresence data-id="element-206" data-mp="drhx0ndveqfr">
        {visible && !dismissed && <motion.aside initial={{
        opacity: 0,
        y: 28,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 22,
        scale: 0.96
      }} transition={{
        type: 'spring',
        stiffness: 280,
        damping: 24
      }} className="fixed bottom-4 left-4 z-[60] max-w-[300px] overflow-hidden rounded-2xl border-2 border-gold bg-primary p-3 pr-8 shadow-[0_18px_42px_rgba(14,165,233,.45)]" aria-live="polite" data-id="element-207" data-mp="dtcflv1o66go">
            <div className="absolute inset-y-0 left-0 w-1.5 bg-gold" data-id="element-208" data-mp="11gaw2spsheel" />
            <div className="absolute right-0 top-0 h-12 w-12 rounded-bl-full bg-white/20" data-id="element-209" data-mp="15j78g1oqkea3" />
            <button onClick={() => setDismissed(true)} className="absolute right-1.5 top-1.5 rounded p-1 text-sky-100 transition-colors hover:text-white" aria-label="Cerrar notificación" data-id="element-210" data-mp="1agqv9pzi1zdn">
              <XIcon className="h-3.5 w-3.5" data-id="element-211" data-mp="32kwixocm6oxt" />
            </button>
            <div className="flex gap-3" data-id="element-212" data-mp="3gbi3dhhpv6xt">
              <span className="h-fit rounded-full border-2 border-amber-100 bg-gold p-2 text-white shadow-sm" data-id="element-213" data-mp="3gcjh5tq4a7j8">
                <ShoppingBagIcon className="h-5 w-5" data-id="element-214" data-mp="3q8mhcu1erw3j" />
              </span>
              <div data-id="element-215" data-mp="3q6tb3fupjdw2">
                <p className="flex items-center gap-1 text-[10px] font-extrabold uppercase tracking-[.12em] text-amber-200" data-id="element-216" data-mp="3qah0q3x17g5i">
                  <CheckCircle2Icon className="h-3 w-3" data-id="element-217" data-mp="34gca3abk420" /> Compra reciente
                </p>
                <p className="mt-1 text-xs leading-snug text-sky-50" data-id="element-218" data-mp="3uahju1v2sfiw">
                  <b className="text-white" data-id="element-219" data-mp="3u8et1fm3mid4">{name}</b> compró el libro digital{' '}
                  <b className="text-amber-200" data-id="element-220" data-mp="24vjouy3rrsp7">{plan}</b>
                </p>
                <p className="mt-1 flex items-center gap-1 text-[10px] font-medium text-sky-100" data-id="element-221" data-mp="1zxi6kfe63xes">
                  <MapPinIcon className="h-3 w-3 text-amber-200" data-id="element-222" data-mp="ffh4tlznj676" />
                  {city} · Argentina · hace {index * 6 + 2} min
                </p>
              </div>
            </div>
          </motion.aside>}
      </AnimatePresence>

      <AnimatePresence data-id="element-223" data-mp="6k1cxaigj148">
        {cta && <motion.a href="#pricing" initial={{
        y: 80,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 80,
        opacity: 0
      }} className="fixed bottom-3 left-3 right-3 z-50 rounded-2xl bg-primary py-3.5 text-center font-display text-sm font-bold text-white shadow-lg shadow-primary/30 md:hidden" data-id="element-224" data-mp="ame8j63hpina">
            QUIERO MI COMBO ESPALDA Y COLUMNA →
          </motion.a>}
      </AnimatePresence>
    </>;
}